import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Custom hook to determine if the current language is RTL
 * @returns Object containing isRTL boolean and current language
 */
export const useLanguageDirection = () => {
  const { i18n } = useTranslation();
  
  const isRTL = useMemo(() => {
    const currentLang = i18n.language;
    return currentLang === 'ar' || currentLang === 'ur' || currentLang === 'fa';
  }, [i18n.language]);
  
  return { 
    isRTL,
    currentLanguage: i18n.language 
  };
};

export default useLanguageDirection; 